const accordionHeader = document.querySelectorAll(".accordion-header");

accordionHeader.forEach(accordionHeader => {
    accordionHeader.addEventListener('click',  event  => {
        accordionHeader.classList.toggle("active")
        const accordionBody = accordionHeader.nextElementSibling
        if(accordionBody.classList.contains("hidden")) {
            accordionBody.classList.remove("hidden")
        } else
        {
            accordionBody.classList.add("hidden")
        }
    });
});




